<div class="communication-settings">
  <h3 class="label-header-text">Scout communication</h3>
  <div class="interval-fields">
    <mat-form-field appearance="outline" subscriptSizing="dynamic">
      <mat-label>{{ isVersionNew ? 'Polling interval' : 'Scout interval' }}</mat-label>
      <input matInput type="number" (input)="updateCommandString()" [(ngModel)]="pollCounterValue">
      <span matTextSuffix>min</span>
      <mat-hint>{{ pollCounterInHours }} hours</mat-hint>
    </mat-form-field>
    @if (isVersionNew) {
      <mat-form-field appearance="outline" subscriptSizing="dynamic">
        <mat-label>Sending interval</mat-label>
        <input matInput type="number" (input)="updateCommandString()" [(ngModel)]="sendCounterValue">
        <span matTextSuffix>min</span>
        <mat-hint>{{ sendCounterInHours }} hours</mat-hint>
      </mat-form-field>
    }
  </div>
  @if (scout) {
    <div class="communication-option">
      <div><h4>Send on every request</h4><p>Send the command each time this Scout requests an update.</p></div>
      <mat-slide-toggle [(ngModel)]="scout.sendCommandOnEachRequest" aria-label="Send command on every request"></mat-slide-toggle>
    </div>
  }
  <div class="command-section">
    <div class="communication-option command-heading">
      <div><h4>Device command</h4><p>Generated from the intervals above.</p></div>
      <mat-slide-toggle [(ngModel)]="editCommand" name="editCommand" (change)="editCommandChangeEvent()">Edit command</mat-slide-toggle>
    </div>
    <mat-form-field appearance="outline" subscriptSizing="dynamic" class="command-field">
      <mat-label>Command to send</mat-label>
      <input matInput [(ngModel)]="command" [formControl]="sendCommandFormControl" />
    </mat-form-field>
    <details class="command-help">
      <summary>Command format reference</summary>
      <p>Scout 3.x.x and up: <code>{{'{'}}{{'{'}}SCT{{'}'}}{{'{'}}INT,60{{'}'}}{{'{'}}SEN,60{{'}'}}{{'}'}}</code></p>
      <p>Scout 2.x.x: <code>'\r''\n''\r''\n'{{'{'}}1,60{{'}'}}'\r''\n'</code></p>
    </details>
  </div>
  <div class="communication-actions">
    <button mat-flat-button type="button" (click)="update()" [disabled]="loading" class="communication-save">
      <mat-icon>send</mat-icon>{{ loading ? 'Sending…' : 'Set intervals & send command' }}
    </button>
  </div>
  @if (loading) { <mat-progress-bar mode="query"></mat-progress-bar> }
</div>
